import {
  CaretDownFilled,
  CaretUpFilled,
  DeleteFilled,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Upload,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState } from "react";
import Heading from "../../../../../components/common/heading";
import ConfirmModal from "../../../../../components/modal/confirmModal";
import FailModal from "../../../../../components/modal/failModal";
import SuccessModal from "../../../../../components/modal/successModal";
import "../../style.css";
import { ThaiDatePicker } from "../../../../../components/common/thaiDatePicker";

const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

const Contact = ({
  actionType,
  file,
  errMgeFile,
  defaultFile,
  setFile,
  setErrMgeFile,
  setDefaultFile,
  handleReaderImageFiles,
  customRequestImage,
  props,
  onRemoveFile,
  onUploadFile,
  fileList,
  setFileList,
  dropDownCurerntStatus,
  onChangeCurrentStatus,
}) => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [elems, setElems] = useState(0);
  const [dateValue, setDateValue] = useState();
  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });
  const [openModal, setOpenModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("คุณต้องการลบข้อมูล ?");
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const [nameID, setNameID] = useState("");
  const [positionCollapse, setPositionCollapse] = useState(undefined);
  const [noAction, setNoAction] = useState(false); // for check 1st when come in this page

  const handleCancel = () => {
    setOpenModal(false);
  };

  return (
    <Content>
      <Row
        gutter={[16, 8]}
        className="card addElement"
        style={{ marginTop: 30, marginBottom: 50 }}
      >
        <Col span={24}>
          <Heading
            text={"สรุปการติดต่อรายครั้ง"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>

        <Form.List name={"contact"}>
          {(fields, { add, remove }) => {
            const reset = (name) => {
              setConfirmLoading(true);
              setOpenModal(true);
              setConfirmLoading(false);
              setNameID(name);
            };
            const removeCF = () => {
              setConfirmLoading(true);
              setOpenModal(false);
              setConfirmLoading(false);
              remove(nameID);
            };

            return (
              <>
                {fields.map(({ key, name, ...restField }, k) => (
                  <Col key={key} span={24}>
                    <div
                      className={`relative`}
                      style={{
                        padding: 15,
                        marginBottom: 20,
                        width: "80%",
                        border: "1px solid #E5EAEE",
                        borderRadius: 10,
                      }}
                    >
                      <Row
                        gutter={[16, 8]}
                        style={{
                          height: noAction
                            ? 80
                            : positionCollapse === k
                            ? 80
                            : "",
                          overflow: noAction
                            ? "hidden"
                            : positionCollapse === k
                            ? "hidden"
                            : "",
                        }}
                      >
                        <div className="add-future-collapse-btn">
                          <Button
                            shape="circle"
                            size="small"
                            style={{
                              backgroundColor: "#FDE7E5",
                              border: 0,
                            }}
                            onClick={() => reset(name)}
                          >
                            <DeleteFilled style={{ color: "#F04438" }} />
                          </Button>
                          <Button
                            shape="circle"
                            size="small"
                            style={{
                              backgroundColor: "#F4F6FC",
                              border: 0,
                              marginLeft: 5,
                            }}
                            onClick={() => {
                              k !== positionCollapse
                                ? setPositionCollapse(k)
                                : setPositionCollapse(undefined);

                              setNoAction(false);
                            }}
                          >
                            {!noAction && k !== positionCollapse ? (
                              <CaretUpFilled
                                style={{
                                  color: "#2E90FA",
                                  fontSize: 16,
                                }}
                              />
                            ) : (
                              <CaretDownFilled
                                style={{
                                  color: "#2E90FA",
                                  fontSize: 16,
                                }}
                              />
                            )}
                          </Button>
                        </div>
                        <Col span={24}>
                          <Row gutter={[8, 16]}>
                            <Col span={6}>
                              <Form.Item
                                {...restField}
                                name={[name, "contact_no"]}
                                label="การติดต่อครั้งที่"
                                rules={[
                                  {
                                    required: true,
                                    message: "โปรดระบุ",
                                  },
                                ]}
                                initialValue={k + 1}
                              >
                                <Input 
                                  placeholder="การติดต่อครั้งที่" 
                                  readOnly
                                />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item
                                {...restField}
                                label="วัน/เดือน/ปี ที่รับลูกค้า"
                                name={[name, "date_contact"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "โปรดระบุ",
                                  },
                                ]}
                              >
                                <ThaiDatePicker
                                  //  onChange={onSelectDate}
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item
                                {...restField}
                                name={[name, "name_staff"]}
                                label="ชื่อเจ้าหน้าที่"
                                rules={[
                                  {
                                    required: true,
                                    message: "โปรดระบุ",
                                  },
                                ]}
                              >
                                <Input placeholder="ชื่อเจ้าหน้าที่" />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item
                                {...restField}
                                label="สถานะปัจจุบัน"
                                name={[name,"currentStatus"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "โปรดระบุ",
                                  },
                                ]}
                              >
                                <Select
                                  allowClear
                                  showSearch={false}
                                  className="w-full"
                                  placeholder="กรุณาเลือก"
                                  optionFilterProp="children"
                                  // onChange={onChangeCurrentStatus}
                                  hasfeedback="true"
                                >
                                  {dropDownCurerntStatus.map((option, i) => {
                                    return (
                                      <Option key={i} value={option.dataId}>
                                        {option.dataDetailTh}
                                      </Option>
                                    );
                                  })}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24} style={{ paddingTop: 24 }}>
                              <Form.Item
                                label="รายละเอียดการติดต่อ"
                                {...restField}
                                name={[name, "detail_contact"]}
                              >
                                <TextArea rows={4} placeholder="รายละเอียด" />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Col span={16}>
                            <Form.Item
                              {...restField}
                              label="แนบไฟล์ "
                              name={[name, "filePath"]}
                              // required={false}
                              // rules={[
                              //   () => ({
                              //     validator(_, value) {
                              //       if (fileList[name] === undefined) {
                              //         return Promise.reject(
                              //           new Error("โปรดระบุ")
                              //         );
                              //       } else {
                              //         return Promise.resolve();
                              //       }
                              //     },
                              //   }),
                              // ]}
                              rules={[
                                {
                                  required: false,
                                  message: "โปรดระบุ",
                                },
                              ]}
                            >
                              <Upload
                                {...props}
                                accept="image/jpg,image/jpeg,application/pdf"
                                customRequest={(e) => {
                                  onUploadFile(e, name);
                                }}
                                onRemove={(info) => {
                                  onRemoveFile(info, name);
                                }}
                                fileList={
                                  fileList.length > 0
                                    ? fileList.filter(
                                        (obj, index) =>
                                          fileList.findIndex(
                                            (item) =>
                                              item.uid === obj.uid &&
                                              item.index === name
                                          ) === index
                                      )
                                    : undefined
                                }
                                multiple={false}
                              >
                                <Button icon={<UploadOutlined />}>
                                  เลือกไฟล์
                                </Button>
                              </Upload>

                              <span style={{ color: "#667085", fontSize: 13 }}>
                                สามารถ Upload File ได้ 1 File รองรับนามสกุล JPG,
                                PDF ขนาดไม่เกิน 50 Mb
                              </span>
                            </Form.Item>
                          </Col>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}

                <ConfirmModal
                  title={"ยืนยันการลบข้อมูล"}
                  open={openModal}
                  modalText={modalText}
                  onOk={removeCF}
                  confirmLoading={confirmLoading}
                  onCancel={handleCancel}
                  actionType={"delete"}
                />

                <Col span={24}>
                  <Button
                    style={{
                      background: "#2E90FA",
                      color: "#fff",
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      add();
                      setElems((prev) => prev + 1);
                    }}
                  >
                    <PlusOutlined /> เพิ่ม
                  </Button>
                </Col>
              </>
            );
          }}
        </Form.List>
      </Row>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        open={failModal}
        setOpen={setFailModal}
        title={"มีบางอย่างผิดพลาด"}
        subTitle={"มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"}
      />
    </Content>
  );
};

export default Contact;
